// open-redirect 가드 — 외부 origin 으로의 redirect 차단.
// `redirectUrl` 은 `?state=` base64url(서명·암호화 아님 → 사용자 조작 가능)에서 오므로, 자기 origin 일
// 때만 `window.location.replace` 를 허용한다(타 origin·protocol-relative·파싱 실패 = 차단). 토스 콜백
// 왕복 복귀 URL(결제 진입 화면) 등 외부에서 돌아오는 풀 URL 에 적용.

/** `url` 이 현재 페이지와 같은 origin 인가(open redirect 가드). 파싱 실패·타 origin = false. */
export function isSameOriginUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}

/**
 * redirect 허용 호스트 allowlist — 현재 호스트 외에 추가로 신뢰하는 호스트(`hostname:port`).
 * 비어있으면 same-host 만 허용. cross-host 복귀가 필요하면 여기 호스트를 명시한다
 * (와일드카드·사용자 입력 금지 — open-redirect 방어). 예: `'app.heviton.com'`.
 */
export const TRUSTED_REDIRECT_HOSTS: readonly string[] = [];

/**
 * redirect URL 이 안전한가 — **현재 호스트와 같거나** allowlist 에 든 호스트만 허용.
 * 상대 경로(`/x`)는 current origin 기준 파싱돼 same-host → 허용. 파싱 실패·그 외 호스트 = 차단.
 * `isSameOriginUrl`(strict origin, 토스 콜백용)과 달리 호스트 기준 + allowlist 를 본다.
 */
export function isSafeRedirectUrl(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const { host } = new URL(url, window.location.origin);
    return host === window.location.host || TRUSTED_REDIRECT_HOSTS.includes(host);
  } catch {
    return false;
  }
}
